jQuery(document).ready(function($){

  $('.price__box_wrapper').insertAfter('.castle-reviews-container');

  
  var castleVariantOptions = $('#castle-variant-options');
  var castleVariantOptionsSelections = $('#castle-variant-options .selectors');
  
  function processYmqOptions() {

    
    $('.ymq-options-box:not(.castle-fabric-swatches)').each(function(index, element) {
        var item = $(element);
        var label = item.attr('data-label');

        var imageURL = 'https://dummyimage.com/100x100/000/fff';
        switch (label){
          case 'Size':
            imageURL = 'https://cdn.shopify.com/s/files/1/0570/0170/5607/files/New_Size_Icon_3ec3be47-eeda-46fd-b8d8-62a08e3ba17a.svg?v=1782908378';
          break;
          case 'Headboard Height':
            imageURL = 'https://cdn.shopify.com/s/files/1/0570/0170/5607/files/New_Headboard_Height_Icon_c2d34ddf-921e-4bb3-8133-a2a4fab857d6.svg?v=1782908056';
          break;
          case 'Studs':
            imageURL = 'https://cdn.shopify.com/s/files/1/0570/0170/5607/files/New_Stud_Icon_4d2a61ac-4d66-4308-a8b6-2cebc4b7f784.svg?v=1782908157';
          break;

          case 'Fabric':
            imageURL = 'https://cdn.shopify.com/s/files/1/0570/0170/5607/files/New_Icon_Fabric.svg?v=1783425959';
          break;

          case 'Ottoman Gas Lift Storage':
            imageURL = 'https://cdn.shopify.com/s/files/1/0570/0170/5607/files/New_Ottoman_Storage_Icon_971ce74d-a8f3-435e-9f77-6482903641f5.svg?v=1782908210';
          break;

          case 'Ottoman Storage':
            imageURL = 'https://cdn.shopify.com/s/files/1/0570/0170/5607/files/Storage_Option.png?v=1752850158';
          break;

          case 'Storage Option':
            imageURL = 'https://cdn.shopify.com/s/files/1/0570/0170/5607/files/New_Storage_Option.png?v=1783075791';
          break;
            
        }

        
        
        // var customClass = (i === 0) ? 'active' : '';

        var html = '';
        html+= `
          <div class="selector-item" data-option="${label}" data-index="${index}">
            <div class="item-image"><img alt="${label}" class="img-fluid" src="${imageURL}"/></div>
            <p>${label}</p>
          </div>
        `;
        castleVariantOptionsSelections.append(html);

        var selectorOptionsClass = (index == 0) ? 'active' : '';

        $('.castle-fabric-swatches').addClass('hide');
      
        // Get selector options
        if (label != 'Fabric'){
          var selectorOptions = '';
          selectorOptions += `<div class="selector-options ${selectorOptionsClass}" data-label="${label}">`;
          
          $(this).find('.spotlight-group label').each(function(optionIndex, optionElement) {
  
            var optionElement = $(optionElement);
            var toolTip = optionElement.find('.ymq_tooltip_show');


            
            var optionName = toolTip.html().trim(); 

            var optionTitleOnly = toolTip.clone()            // Clone the element
                  .children()              // Get the child elements (like <span>)
                  .remove()                // Remove the child elements
                  .end()                   // Go back to the cloned parent
                  .text()                  // Get only the text
                  .trim();                 // Trim extra whitespace

            
            var optionImage = optionElement.css('background-image');
            var optionID = optionElement.attr('for');
  
            optionImage = optionImage.replace(/"/g, "'");
            
            selectorOptions += `
            <div class="option" data-id="${optionID}" data-index="${index}" data-option="${optionTitleOnly}">
              <div class="image" style="background-image:${optionImage}" ></div>
              <div class="title">${optionName}</div>
            </div>`; // Use optionName
          });
          
          selectorOptions += `</div>`;
          
          $('.selectors-options').append(selectorOptions);
        }

        
    });
    

    $('.selector-item').first().addClass('active');
    
  }

  var currentIndex = 0;
  $(document).on('click','.selector-options .option',function(){


      $('.castle-total-price').remove();
    
      var optionID = $(this).attr('data-id');
      var optionIndex = $(this).attr('data-index');
      var optionTitle = $(this).attr('data-option');

      currentIndex = optionIndex;

      var parent = $(this).parents('.selector-options');
      parent.find('.option').removeClass('active');

      var label = parent.attr('data-label');

      // Update Mattress
      if (label == 'Size'){
        $('.related_main_prod_cover').hide();
        $('.related_main_prod_cover[data-title="'+optionTitle+'"]').show();
      }
      

      $(this).addClass('active');

      $('label.ymq-options-img-label[for="' +optionID+ '"]').trigger('click');

      if (currentIndex < $('.selector-options').length){

        $('.selector-item[data-index="' + currentIndex + '"]').addClass('selected'); // Add class selected
        
        currentIndex++;
        
        setTimeout(() => {
          $('.selector-item[data-index="' + currentIndex + '"]').trigger('click');
        }, 1000);
      }


      checkPriceChanges();
     
    
  });


  $(document).on('change','.quantity__input',function(){
    checkPriceChanges();
  });
  
  function checkPriceChanges(){
    
    setTimeout( () => {
        if ($('#ymq-addons-price').length && $('#ymq-addons-price').html() != ''){

          var quantity = $('.quantity__input').val();
          var additional = $('#ymq-addons-price span').attr('data-ymq-money');
          var basePrice = $('#castle-variant-options').attr('data-price');

          var total = parseInt(quantity) * (parseFloat(additional) + (parseInt(basePrice) / 100) );
          total = total.toFixed(2);

          $('.castle-total-price').remove();
          
          var totalPriceHTML = '<span class="castle-total-price"> - £' + total + '</span>';
          $('.product-form__submit').append(totalPriceHTML);
          
        }
    },1000);
  }

  $(document).on('click','.castle-fabric-swatches label',function(){
      if (currentIndex < $('.selector-options').length){

        $('.selector-item[data-index="' + currentIndex + '"]').addClass('selected'); // Add class selected
        
        currentIndex++;
        setTimeout(() => {
          $('.selector-item[data-index="' + currentIndex + '"]').trigger('click');
        }, 1000);
      }
  });
  
  function waitForYmqBox(callback) {
      const observer = new MutationObserver(function(mutations, obs) {
          if ($('#ymq-box').length) {
              obs.disconnect();
              if (typeof callback === 'function') {
                  callback();
              }
          }
      });
  
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  }

  // Call it
  waitForYmqBox(processYmqOptions);


  
  $(document).on('click','#castle-variant-options .selectors .selector-item',function(){
      

     

      var option = $(this).attr('data-option');
      var index = $(this).attr('data-index');
      var previousIndex = index - 1;


      $('.variant-error').remove();
  

      
      // Check previous index
      var previousIndexElement = $('.selector-item[data-index="'+previousIndex+'"]');

    
      if (previousIndexElement.length || index == 0){
        if (previousIndexElement.hasClass('selected') || index == 0){

            $(this).siblings().removeClass('active');
            $(this).addClass('active');

            $('.castle-fabric-swatches').addClass('hide');

            // Selections
            $('#castle-variant-options .selector-options').removeClass('active');

          
           // Remove fabric class
            $('.ymq-options-box[data-name="properties[Fabric]"]').removeClass('active');
      
            if (option == 'Fabric'){
              $('.ymq-options-box[data-name="properties[Fabric]"]').addClass('active');
              $('.castle-fabric-swatches').removeClass('hide');


              
            }else{
              $('#castle-variant-options .selector-options[data-label="'+option+'"]').addClass('active');
            }
        }else{
          $('#castle-variant-options').prepend('<div class="variant-error">'+'Please choose ' + previousIndexElement.attr('data-option')+'</div>');
        }
      }
    

     


      

      
  });

  initSwatchDimensions(); // Castle July 2025


  function initSwatchDimensions() {
      const allowedTemplates = ['product-one-1','product-one-2','product-one-3','product-one-4'];
      const template = $('.castle-product-handle').data('template');
    
      if (allowedTemplates.includes(template)) {
        const $wrappers = $('.spb-productoptionswatchwrapper');
        const $dimensionsContents = $('.dimensions_content');

        $('.dimensions_content ul.dimensions_data + p').before(`
          <p class="dimensions-data-text">
            If Ottoman Divan Storage is selected please allow for additional 6" of width and 2-5" of length
          </p>
        `);
                
      }else{
        console.log('template not included for text')
      }
    }


  function moveAddOns() {
    var $addOns = $('.add-ons-container');
    var $builder = $('[data-bc-builder]');

    if ($(window).width() <= 768) {
      // Mobile: directly below the Bed Builder if there is one, otherwise after
      // .castle-pay-in-terms-container. Skip if already in place, so nothing moves.
      var $target = $builder.length ? $builder : $('.castle-pay-in-terms-container');
      if ($target.length && !$target.next().is($addOns)) $target.after($addOns);
    } else {
      // Desktop: Move after .product__media_container
      var $media = $('.product__media_container');
      if ($media.length && !$media.next().is($addOns)) $media.after($addOns);
    }
  }

  // Run on page load
  moveAddOns();

  // Re-run only when the width changes (rotating the phone, resizing a desktop
  // window). On mobile, scrolling shows and hides the browser toolbar, which
  // fires resize with a new height only; reacting to that made the page jump.
  let resizeTimer;
  let lastWidth = window.innerWidth;
  $(window).resize(function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(moveAddOns, 250);
  });

  
});